import { LogoHolder } from "../../nq-component";
import classNames from "../../classNames";
import React from "react";

const defaultProps = {
  navigateIcon: "bi bi-list",
};

function NavBar2({
  className,
  onClickNavigate,
  navigateIcon,
  logo,
  title,
  action,
  user,
}) {
  const classes = classNames(
    className,
    "navbar navbar-expand-lg navbar-light bg-white",
  );
  return (
    <nav className={classes}>
      <div className="container-fluid">
        <button
          onClick={onClickNavigate}
          type="button"
          className="btn btn-sm btn-link fs-4 ps-0 text-dark"
        >
          <i className={navigateIcon}></i>
          {logo && (
            <img
              className="w-auto ms-3"
              src={"/lori.jpg"}
              height="40"
              alt="title-logo"
            />
          )}
        </button>
        <div className="d-flex align-items-center">
          {/* {logo && (
            <img className="w-auto" src={logo} height="40" alt="title-logo" />
          )} */}
          {title && <h6 className="fw-bold m-0 ms-2">{title}</h6>}
        </div>
        {(action && action()) || (
          <LogoHolder
            className="bg-dark"
            textClassName="text-white"
            logo={user?.picture}
            name={user?.username}
            width={45}
            height={45}
          />
        )}
      </div>
    </nav>
  );
}

NavBar2.defaultProps = defaultProps;
export default NavBar2;
